module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<% if(hashtag_color) { %> #TelescopeWidgetFanFeed .modal-content .view-media-detail .media-content .media-info .text-content p .hash-link { color: <%- hashtag_color %>; } <% } %> <% if(headline_text_color) { %> <%- namespace %> .media-content .media-info .view-tile-details .tile-media .tile-media-body .tile-media-heading { <%- headline_text_color.length>0? 'color: '+headline_text_color+';' : '' %> } <% } %> <% if(paragraph_text_color) { %> <%- namespace %> .media-content .media-info .text-content p { <%- paragraph_text_color.length>0? 'color: '+paragraph_text_color+';' : '' %> } <% } %> <% if(color) { %> <%- namespace %> .media-content .media-info .text-content p { <%- color.length>0? 'color: '+color+';' : '' %> } <% } %> <% if(background_color) { %> <%- namespace %> .media-content { <%- background_color.length>0? 'background-color: '+background_color+';' : '' %> } <% } %> <% if(social_action_icons) { %> <%- namespace %> .media-content .text-content li svg { <%- social_action_icons.length>0? 'fill: '+social_action_icons+';' : '' %> } <% } %> @media(max-width: 749px){ <% if(arrow_color_mobile && arrow_color_mobile.length > 0) { %> <%- namespace %> .icon-arrow-right,\t<%- namespace %> .icon-arrow-left { <%- arrow_color_mobile.length>0? 'color: '+arrow_color_mobile+';' : '' %> } <% } %> } @media(min-width: 750px){ <% if(arrow_color_desktop && arrow_color_desktop.length > 0) { %> <%- namespace %> .icon-arrow-right,\t<%- namespace %> .icon-arrow-left { <%- arrow_color_desktop.length>0? 'color: '+arrow_color_desktop+';' : '' %> } <% } %> } "
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  if(hashtag_color) { 
    ; __append(" #TelescopeWidgetFanFeed .modal-content .view-media-detail .media-content .media-info .text-content p .hash-link { color: ")
    ; __append( hashtag_color )
    ; __append("; } ")
    ;  } 
    ; __append(" ")
    ;  if(headline_text_color) { 
    ; __append(" ")
    ; __append( namespace )
    ; __append(" .media-content .media-info .view-tile-details .tile-media .tile-media-body .tile-media-heading { ")
    ; __append( headline_text_color.length>0? 'color: '+headline_text_color+';' : '' )
    ; __append(" } ")
    ;  } 
    ; __append(" ")
    ;  if(paragraph_text_color) { 
    ; __append(" ")
    ; __append( namespace )
    ; __append(" .media-content .media-info .text-content p { ")
    ; __append( paragraph_text_color.length>0? 'color: '+paragraph_text_color+';' : '' )
    ; __append(" } ")
    ;  } 
    ; __append(" ")
    ;  if(color) { 
    ; __append(" ")
    ; __append( namespace )
    ; __append(" .media-content .media-info .text-content p { ")
    ; __append( color.length>0? 'color: '+color+';' : '' )
    ; __append(" } ")
    ;  } 
    ; __append(" ")
    ;  if(background_color) { 
    ; __append(" ")
    ; __append( namespace )
    ; __append(" .media-content { ")
    ; __append( background_color.length>0? 'background-color: '+background_color+';' : '' )
    ; __append(" } ")
    ;  } 
    ; __append(" ")
    ;  if(social_action_icons) { 
    ; __append(" ")
    ; __append( namespace )
    ; __append(" .media-content .text-content li svg { ")
    ; __append( social_action_icons.length>0? 'fill: '+social_action_icons+';' : '' )
    ; __append(" } ")
    ;  } 
    ; __append(" @media(max-width: 749px){ ")
    ;  if(arrow_color_mobile && arrow_color_mobile.length > 0) { 
    ; __append(" ")
    ; __append( namespace )
    ; __append(" .icon-arrow-right,	")
    ; __append( namespace )
    ; __append(" .icon-arrow-left { ")
    ; __append( arrow_color_mobile.length>0? 'color: '+arrow_color_mobile+';' : '' )
    ; __append(" } ")
    ;  } 
    ; __append(" } @media(min-width: 750px){ ")
    ;  if(arrow_color_desktop && arrow_color_desktop.length > 0) { 
    ; __append(" ")
    ; __append( namespace )
    ; __append(" .icon-arrow-right,	")
    ; __append( namespace )
    ; __append(" .icon-arrow-left { ")
    ; __append( arrow_color_desktop.length>0? 'color: '+arrow_color_desktop+';' : '' )
    ; __append(" } ")
    ;  } 
    ; __append(" } ")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}